<!-- @format -->

<template>
  <div>
    <notifications group="client" position="bottom center" />
    <div v-if="clientId == -1">
      <div class="ui attached message" v-show="showNewProposal">
        <div class="content">
          <div class="header">New Plan</div>
        </div>
      </div>
      <ClientSimpleListV2
        v-on:handleClientSelected="handleClientSelected($event)"
      />
    </div>
    <div v-if="!showFinalStep && clientId != -1">
      <div class="ui  padded attached message">
        <div class="content">
          <div class="header">
            New Investment Plan for {{ clientInfo.fullName }}
          </div>
        </div>
      </div>
      <div class="ui attached very basic segment">
        <div class="ui padded segment">
          <div class="ui form">
            <h3>
              Step 1: Name your {{appName}} Investment Plan 
              <span style="color: green" v-if="proposalName != ''">✔</span>
            </h3>

            <div class="ui field">
              <label>Investment Plan Name</label>
              <input type="text" v-model="proposalName" />
            </div>
            <div class="ui field">
              <label>Description (optional)</label>
              <input type="text" v-model="proposalDescription" />
            </div>
            <h3>
              Step 2: Customise cover letter?
              <div class="ui checkbox">
                <input
                  type="checkbox"
                  name="example"
                  v-model="applyCustomCoverText"
                />
                <label v-if="applyCustomCoverText">Yes</label>
                <label v-if="!applyCustomCoverText">No</label>
              </div>
            </h3>

            <div class="ui field" v-if="applyCustomCoverText">
              <label>Cover Letter - text</label>
              <textarea rows="15" v-model="customCoverText" />
            </div>
            <h3>
              Step 3: Add goals to your investment plan
              <span
                style="color: green"
                v-if="filter(goalsComputed, { selected: true }).length > 0"
                >✔</span
              >
            </h3>
            <div class="ui very basic segment">
              <table class="ui table">
                <tbody>
                  <tr v-if="!g.selected" v-for="(g, index) in goalsComputed">
                    <td style="width: 150px">
                      <div
                        class="ui tiny button"
                        @click.prevent="selectGoal(g, index)"
                      >
                        Add Goal
                      </div>
                    </td>
                    <td>
                      {{ g.requestObject.goalInfo.goalName }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                class="ui table"
                v-if="filter(goalsComputed, { selected: true }).length > 0"
              >
                <thead>
                  <tr>
                    <th colspan="2">Goals in Proposal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="g.selected" v-for="(g, index) in goalsComputed">
                    <td style="width: 150px">
                      <div
                        class="ui tiny button"
                        @click.prevent="selectGoal(g, index)"
                      >
                        Remove
                      </div>
                    </td>
                    <td>
                      {{ g.requestObject.goalInfo.goalName }} 
                    </td>
                  </tr>
                </tbody>
              </table>
              <strong>
                {{ filter(goalsComputed, { selected: true }).length }}</strong
              >
              goals added to Proposal
              <span style="display: none">{{ selectedGoals }}</span>
            </div>

            <div
              v-if="
                filter(goalsComputed, { selected: true }).length > 0 &&
                  proposalName != ''
              "
            >
              <div class="ui divider"></div>
              <span>
                <div
                  class="ui primary large button"
                  @click.prevent="createGoals"
                >
                  Create Plan
                </div>
                <div
                  class="hollow-dots-spinner"
                  v-if="loading"
                  :style="spinnerStyle"
                >
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div></div
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showFinalStep && clientId != -1">
      <div class="ui attached message ">
        <h1>😀 Success</h1>
        <p>Great. You have successfully created an investment plan</p>
      </div>
      <div class="ui padded attached segment">
        <div class="content">
          <h3>Step 1. Review Client Investment Plan</h3>

          <div class="ui attached message">
            It is a good idea to review it before sending onto client.
          </div>
          <div class="ui attached segment">
            <div>
              <i class="ui external alternate icon"></i>
              <a :href="proposalLink" target="_blank">View Plan</a>
            </div>
          </div>

          <h3>Step 2. Share the link & access code with your client.</h3>
          <div class="ui attached message">
            Here is some suggested text which you can email to your client.
          </div>
          <div class="ui attached segment">
            <div class="ui ">
              <span ref="htmlMessage" v-html="htmlMessage"></span>
              <br />
              <a class="ui label" @click.prevent="copyURL"
                ><i class="ui copy outline icon"></i> Copy text
              </a>
            </div>
          </div>
          <h3>Step 3. Client accepts or rejects plan.</h3>
          <div class="ui attached message">
            Great job. You have done the hard yards.
          </div>
          <div class="ui attached segment">
            <p>
              PortfolioLink will send you an email once the client has accepted
              or rejected the investment plan. <br /><br />
              Alternatively, you can monitor the status of each plan under
              <strong><router-link to="/v2/plans">Plans</router-link></strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import numeral from "numeral";
import vSelect from "vue-select";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import "vue-select/dist/vue-select.css";
import ClientSimpleListV2 from "@/components/ClientSimpleListV2.vue";
import {
  getClientGoalsV2,
  getClient,
  createClientProposalsV2,
  ProposalUrl,
} from "@/gateway.js";

import { mapGetters } from "vuex";
export default {
  name: "GoalTypes",
  components: { ClientSimpleListV2 },
  props: ["clientId"],
  data() {
    return {
      applyCustomCoverText: false,
      customCoverText: "",
      loading: false,
      step: 1,
      goals: [],
      proposalLink: "",
      selectedGoals: [],
      plainMessage: "",
      htmlMessage: "",
      clientInfo: null,
      proposalName: "",
      proposalDescription: "",
      createdPlanDetails: null,
      showFinalStep: false,
    };
  },
  computed: {
	  appName() {
		  let app = this.$store.state.appName;// ?? "";
		  if (!app)
		  {
				return "PortfolioLink";
		  }
		  if (app.toString().toLowerCase().includes("quest")){
			  return "QuestLink";
		  }
		  if (this.$store.state.appName) return this.$store.state.appName;
		  else return "";
	  },
    goalsComputed() {
      var final = [];
      if (this.goals.length > 0) {
        for (var i = 0; i < this.goals.length; i++) {
          if (!this.goals[i].selected) this.goals[i].selected = false;
          final.push(this.goals[i]);
        }
      }

      return final;
    },
    ...mapGetters(["partnerName"]),
  },
  methods: {
    async handleClientSelected(event) {
      this.clientId = event.clientId;
      await this.init();
    },
    copyURL() {
      var copyLink = this.plainMessage; // this.$refs.htmlMessage.textContent;
      // var f = copyLink.replace(/<br>/g, "\n").replace(/<\/?[^>]+>/g, "");
      const el = document.createElement("textarea");

      el.value = copyLink;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        this.$notify({
          group: "client",
          title: "Text copied to clipboard",
          position: "bottom right",
          type: "success",
        });
      }
    },
    async createGoals() {
      this.loading = true;
      const response = await createClientProposalsV2({
        clientId: this.clientId,
        goalIds: this.selectedGoals,
        proposalName: this.proposalName,
        proposalDescription: this.proposalDescription,
        customCoverText: this.applyCustomCoverText ? this.customCoverText : "",
	      appName: this.appName
      });
      if (response) {
        this.loading = false;
      }
      if (response.success) {
        /*this.showFinalStep = true;
        this.createdPlanDetails = response.proposal;
        this.clientDetails = response.client;
        this.proposalLink = ProposalUrl + this.createdPlanDetails.guid;
        this.htmlMessage =
          "<p>Dear " +
          this.clientInfo.firstName +
          ", <br /><br /> as discussed here is your investment plan. Please review it and accept/reject it.  </p>" +
          "<p> You can view it here: <strong><a :href='" +
          this.proposalLink +
          "'></strong>" +
          this.proposalLink +
          "</a>.<br /> Access code: <strong>" +
          this.createdPlanDetails.clientPwd +
          " </strong></p><br /> Kind regards <br /> <br />";

        this.plainMessage =
          "Dear " +
          this.clientInfo.firstName +
          ", \r\n \r\n as discussed here is your investment plan. Please review it and accept or reject it. " +
          "\r\n - You can view it here: " +
          this.proposalLink +
          "\r\n - Access Code: " +
          this.createdPlanDetails.clientPwd +
          "\r\n  \r\n Kind regards ";
          */

        this.$router.push("/v2/plans/" + response.proposal.guid);
      }
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    formatNr(val, fmt) {
      if (fmt) {
        return numeral(val).format(fmt);
      } else return numeral(val).format("0,0");
    },
    selectGoal(g, index) {
      //  var final = [];
      this.goals[index].selected = !this.goals[index].selected;
      // this.selectedGoals.push(index);

      this.selectedGoals = [];
      for (var i = 0; i < this.goals.length; i++) {
        if (this.goals[i].selected) this.selectedGoals.push(this.goals[i].id);
      }

      this.$set(this, "selectedGoals", this.selectedGoals); //(this, "selectedGoals", this.selectedGoals);
      this.$set(this, "goals", this.goals);
      // this.selectedGoals = final;
    },
    async init() {
      // const response = await getRiskProfiles();
      //  this.riskProfiles = response.result;
      // this.riskProfile = this.riskProfiles[0];

      if (this.clientId != -1) {
        var response = await getClient({
          id: this.clientId,
        });

        this.clientInfo = response.result;
        this.proposalName =
          "Investment Plan for " +
          response.result.fullName +
          " - " +
          moment().format("MMM YYYY");

        const response2 = await getClientGoalsV2({
          clientId: this.clientId,
          pageSize: 50,
        });

        this.goals = response2.result;

        if (response2 && response) {
          this.customCoverText =
            `Dear ${response.result.firstName},

We have created a personalised investment plan for you. It contains details of your ${response2.result
              .map((i) => {
                return i.requestObject.goalInfo.goalName; //JSON.stringify(i.requestObject.goalInfo);
              })
              .toString()}.

We are grateful that you chose us to create & submit an investment plan for you. If there are any questions, please do not hesitate to contact us.

Thank you,

` + this.$store.state.partnerName;
        }
        // this.proposalName = response.result[0].clien
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
.selecthover tr {
  cursor: pointer;
}
</style>
